"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_components_1 = require("@apollo/react-components");
var component_button_1 = __importDefault(require("@doordash/component-button"));
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var LayoutContext_1 = require("../../Common/LayoutContext");
var TwoFactorAuthenticationStrings_1 = __importDefault(require("../TwoFactorAuthenticationStrings"));
var VerifyAccountStyles_1 = require("../VerifyAccountStyles");
var PhoneEmailVerifyPage = function (_a) {
    var apolloClient = _a.apolloClient, children = _a.children;
    var _b = __read(React.useReducer(function (oldState, newState) { return (__assign(__assign({}, oldState), newState)); }, {
        isSubmitting: false,
        isDisabled: false
    }), 2), primaryActionState = _b[0], setPrimaryActionState = _b[1];
    return (React.createElement(react_components_1.ApolloProvider, { client: apolloClient },
        React.createElement(LayoutContext_1.LayoutProvider, { primaryAction: primaryActionState, setPrimaryAction: setPrimaryActionState },
            React.createElement(design_language_1.StackChildren, null,
                children,
                React.createElement(VerifyAccountStyles_1.PageLayoutSubmitContainer, null,
                    React.createElement(component_button_1["default"], { isDisabled: primaryActionState.isDisabled, state: primaryActionState.isSubmitting
                            ? component_button_1["default"].States.Loading
                            : component_button_1["default"].States.Default, onClick: function () { return setPrimaryActionState({ isSubmitting: true }); } }, TwoFactorAuthenticationStrings_1["default"].submit()))))));
};
exports["default"] = PhoneEmailVerifyPage;
